(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('RacePositions', RacePositions);

    RacePositions.$inject = ['$resource'];

    function RacePositions ($resource) {
        var resourceUrl =  'api/race-positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
